import { GalleryView, PLATFORM_OVERLAY_SMALL } from "@gaming/srvg-classes-core";
import { LivesettlementsWidget } from "../../widgets/View/VfWidget/LivesettlementsWidget";

export class SettlementGalleryView extends GalleryView {

    constructor( options ) {
        options = options || {};
        super( options );
    }

    handleDomInstantiated() {

        // Default 2, except for italy becomes 1
        var numOfColumns = (srvg && srvg.config && srvg.config.modeItaly === true) ? 1 : 2;

        super.handleDomInstantiated();
        this.galleryPageContainerView.numberOfItemsToShow = 1;
        if( srvg.widgets.enabled ) {
            // shown in pre match overlay
            if(srvg.widgets.widgets['livesettlements'].enabled){
                for( var i = 0; i < srvg.overlayBettingMarketsSettings.post_match.length; i++ ) {
                    var livesettlementwidget = this.addGalleryItem(new LivesettlementsWidget({
                        widgetGroup: srvg.widgets.widget_group,
                        //selector: this.selector + ' .livesettlement_' + i,
                        platform: PLATFORM_OVERLAY_SMALL,
                        numOfColumns: numOfColumns,
                        marketsOverride: srvg.overlayBettingMarketsSettings.post_match[i],
                        template: app.templateEngine.template( 'livesettlementWidget' ),
                        hideOdds: srvg.featuresInstances.getDisableOdds()
                    }));
                }
            }
        }
    }
}